export function isAnalysisParent(item) {
  if (!item) return false
  return (
    item.name === 'analysis' ||
    item.path === '/analysis' ||
    (item.meta && item.meta.title === '数据分析')
  )
}

const ANALYSIS_CHILD_NAMES = [
  'proRealnameData',
  'officialCarData',
  'preClassCompanyData',
  'preClassBidData',
  'materialData'
]

function analysisChildName(item) {
  if (!item) return ''
  if (ANALYSIS_CHILD_NAMES.indexOf(item.name) >= 0) return item.name
  if (ANALYSIS_CHILD_NAMES.indexOf(item.pageCode) >= 0) return item.pageCode
  const path = (item.path || item.pageUrl || '') + ''
  for (let i = 0; i < ANALYSIS_CHILD_NAMES.length; i++) {
    const name = ANALYSIS_CHILD_NAMES[i]
    if (path.indexOf('/analysis/' + name) === 0) return name
  }
  return ''
}

function normalizeAnalysisPageName(name, orgType) {
  if (name === 'preClassCompanyData' || name === 'preClassBidData') {
    if (isAnalysisLaborOrg(orgType) || isAnalysisBidOrg(orgType)) {
      return 'preClassBidData'
    }
    if (isAnalysisCompanyOrg(orgType)) {
      return 'preClassCompanyData'
    }
  }
  return name
}

function buildAnalysisPath(name, orgUid, rawPath) {
  if (!name || !orgUid) return '/home'
  const path = rawPath || ''
  const suffix = '/' + orgUid
  if (
    path &&
    path.indexOf('/analysis/' + name) === 0 &&
    path.length > suffix.length &&
    path.slice(-suffix.length) === suffix
  ) {
    return path
  }
  return '/analysis/' + name + '/' + orgUid
}

function collectAnalysisChildren(pages) {
  const found = []
  const analysis = Array.isArray(pages) ? pages.find(isAnalysisParent) : null
  const children = (analysis && analysis.children) || []
  children.forEach((child) => {
    const name = analysisChildName(child)
    if (name) found.push({ name: name, path: child.path || '' })
  })
  if (found.length) return found
  const stack = Array.isArray(pages) ? pages.slice() : []
  while (stack.length) {
    const item = stack.shift()
    if (!item) continue
    if (!isAnalysisParent(item)) {
      const name = analysisChildName(item)
      if (name) found.push({ name: name, path: item.path || '' })
    }
    if (item.children && item.children.length) {
      for (let j = 0; j < item.children.length; j++) stack.push(item.children[j])
    }
  }
  return found
}

/**
 * 按侧栏已授权子页决定 /analysis 跳转。
 * 权限树未就绪时回 /home，禁止回退劳务用工（否则顶栏会被误标成班前教育分析）。
 */
export function resolveAnalysisRedirectPath(pages, orgUid, orgType) {
  if (!orgUid) return '/home'
  const list = collectAnalysisChildren(pages)
  if (!list.length) return '/home'
  const preferred = list.map((item) => ({
    name: normalizeAnalysisPageName(item.name, orgType),
    path: item.path
  }))
  const first = preferred[0]
  return buildAnalysisPath(first.name, orgUid, first.path)
}

/** 标段、劳务公司：数据分析默认走标段路由 */
export function isAnalysisBidOrg(orgType) {
  return (
    orgType === 'simPro' ||
    orgType === 'laborCom' ||
    orgType === '劳务分包' ||
    orgType === '项目标段'
  )
}

/** 劳务公司：班前教育分析用班组级样式 */
export function isAnalysisLaborOrg(orgType) {
  return orgType === 'laborCom' || orgType === '劳务分包'
}

/** 企业、工程：数据分析用企业级样式 */
export function isAnalysisCompanyOrg(orgType) {
  return (
    orgType === 'com' ||
    orgType === 'bigPro' ||
    orgType === '企业' ||
    orgType === '工程项目'
  )
}

export function withAnalysisSuffix(title) {
  if (!title) return title
  const text = String(title)
  return text.slice(-2) === '分析' ? text : text + '分析'
}

export function singleAnalysisChild(pages) {
  if (!Array.isArray(pages)) return null
  const analysis = pages.find(isAnalysisParent)
  if (analysis && analysis.children && analysis.children.length === 1) {
    return analysis.children[0]
  }
  return null
}

export function applySingleAnalysisNavTitle(menuPages) {
  const child = singleAnalysisChild(menuPages)
  if (child && child.meta) {
    child.meta.title = withAnalysisSuffix(child.meta.title)
  }
  return menuPages
}

export function analysisHeaderTitle(menuPages, route, fallback) {
  const child = singleAnalysisChild(menuPages)
  const path = route && route.path ? String(route.path) : ''
  if (!child || path.indexOf('/analysis/') !== 0) {
    return fallback
  }
  // 仅当当前路由就是该唯一子页时，才用子页标题；避免停在劳务用工却显示班前教育分析
  const childName = analysisChildName(child)
  const routeName = (route && route.name) || ''
  if (childName && routeName && childName !== routeName) {
    return fallback
  }
  if (childName && path.indexOf('/analysis/' + childName) !== 0) {
    return fallback
  }
  const title = (child.meta && child.meta.title) || fallback
  return withAnalysisSuffix(title)
}

/** 根据路由 path 取 meta.title，供菜单切换/切机构时同步顶栏 */
export function routeMetaTitle(router, path) {
  if (!router || !path) return ''
  try {
    const resolved = router.resolve(path)
    const route = resolved && resolved.route
    if (!route) return ''
    if (route.meta && route.meta.title) return route.meta.title
    const matched = route.matched || []
    for (let i = matched.length - 1; i >= 0; i--) {
      if (matched[i].meta && matched[i].meta.title) {
        return matched[i].meta.title
      }
    }
  } catch (e) {
    return ''
  }
  return ''
}
